import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useSupplierDocumentsApi } from "../../http/supplierDocuments/api";
import { SupplierDocument } from "../../http/supplierDocuments/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteSupplierDocumentDialogProps = {
  supplierDocument: SupplierDocument;
  onClose: () => void;
};

const DeleteSupplierDocumentDialog: FC<DeleteSupplierDocumentDialogProps> = ({ supplierDocument, onClose }) => {
  const i18n = useI18n();
  const supplierDocumentsApi = useSupplierDocumentsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.documents.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            supplierDocumentsApi
              .deleteSupplierDocument(supplierDocument.id, supplierDocument.supplier.id)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.documents.questions.delete}
    </ModalDialog>
  );
};

export default DeleteSupplierDocumentDialog;
